import { selectChangeMessageForAgeRange } from '@UI/aside/asideAgeRange/asideAgeRangeSelectors';
import { selectChangeMessageForConcordanties } from '@UI/aside/asideConcordanties/asideConcordantiesSelectors';
import { selectChangeMessageForDevelopmentPhase } from '@UI/aside/asideDevelopmentPhase/asideDevelopmentPhaseSelectors';
import { selectZillLeerlijnStepNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import {
  selectIsAgeRangeNotEmpty,
  selectIsStartageLowerThanEndage,
} from '@newStore/validation/validationRules/ageRangeValid';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const CURRICULUM_ZILL_LEERLIJN_CLUSTER: BuildingBlockNodeConfig = {
  nodeSelector: selectZillLeerlijnStepNode,
  information: {
    single: 'Stap',
    plural: 'Stappen ',
  },
  buildingBlocks: [],
  edit: [
    {
      component: 'ageRange',
      reactComponent: 'AsideAgeRange',
      label: 'Leeftijd',
      properties: ['startage', 'endage'],
      options: {
        editMonth: true,
      },
      asideChangeMessageSelector: selectChangeMessageForAgeRange,
      validations: [selectIsAgeRangeNotEmpty, selectIsStartageLowerThanEndage],
    },
    {
      component: 'developmentPhase',
      reactComponent: 'AsideDevelopmentPhase',
      label: 'Ontwikkelingsfase',
      showInAncestorTypes: [NodeType.CURRICULUM_ZILL_LEERLIJN_AN],
      asideChangeMessageSelector: selectChangeMessageForDevelopmentPhase,
    },
    descriptionComponent,
    {
      component: 'concordanties',
      reactComponent: 'AsideConcordanties',
      label: 'Concordanties',
      asideChangeMessageSelector: selectChangeMessageForConcordanties,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default CURRICULUM_ZILL_LEERLIJN_CLUSTER;
